import { Text, useStdout } from 'ink';

export default function LoadingText({ text = 'Loading' }: { text?: string }) {
  const { stdout } = useStdout();
  const stdOutRedirected = !stdout?.isTTY;
  if (stdOutRedirected) {
    // Don't write Loading text if we're not in a TTY (e.g... redirected to a file)
    return null;
  }

  return <Text>{text}...</Text>;
}
